import pick from 'lodash.pick';
import snakeCase from 'lodash.snakecase';
import mapKeys from 'lodash.mapkeys';

export function serialize(shipPoint) {
  const {
    address1,
    address2,
    city,
    province,
    postalCode,
    countryCode,
    facilityId,
  } = shipPoint;

  return {
    address_1: address1,
    address_2: address2 || '',
    city,
    state: province,
    zip5: postalCode,
    country_code: countryCode,
    facility_id: facilityId || '',
  };
}

export function transformShipPoint(shipPoint) {
  const { addressType } = shipPoint;

  const fields = ['address1', 'address2', 'city', 'postalCode', 'province',
    'countryCode', 'attentionName', 'companyName', 'phoneNumber'];

  if (addressType === 'facility') {
    fields.push('facilityId');
  }

  const attributes = pick(shipPoint, fields);

  return mapKeys(attributes, (value, key) => snakeCase(key));
}
